// extracted by mini-css-extract-plugin
export default {"statistics":"Statistics_statistics__F1Pvp","content":"Statistics_content__bbOTV","title":"Statistics_title__jukLX","buttons":"Statistics_buttons__-tTLM"};